/**
 * Runtime API config singleton. `setConfig()` is called once at startup
 * (src/main.tsx) from VITE_ env vars; `getConfig()` is read by apiRequest.
 */
type ApiServiceConfig = {
  apiUrl: string;
  env: string | undefined;
  isDevelopment?: boolean;
  isStaging?: boolean;
  isProduction?: boolean;
};

let config: ApiServiceConfig | null = null;

export function setConfig(userConfig: ApiServiceConfig) {
  config = {
    ...userConfig,
    // Vite's dev mode is "dev" (see `vite --mode dev`); "development" kept for
    // the default `vite` mode too.
    isDevelopment: userConfig.env === "dev" || userConfig.env === "development",
    isStaging: userConfig.env === "staging",
    isProduction: userConfig.env === "production",
  };
}

export function getConfig(): ApiServiceConfig {
  if (!config) {
    throw new Error("App config has not been set yet");
  }
  return config;
}
